import { Box, Grid, IconButton, makeStyles, Paper, Typography } from '@material-ui/core'
import React, {useEffect} from 'react'

const useStyles = makeStyles((theme) => ({
    root:{
        border: `1px solid ${theme.palette.secondary.dark}`,
        borderRadius:'5px',
        marginTop:'30px',
        padding:'10px',
        [theme.breakpoints.down('md')]:{
            marginTop:'30px'
        }
    },
    tabHeading:{
        fontSize: '32px',
        fontWeight:550,
        margin:'0'
    },
    noteContainer:{
        padding: 10,
        margin: '10px 0'
    },
    noteHeading:{
        margin: 0,
        fontWeight: 600,
        fontSize: 16
    },
    noteMsg:{
        margin: 0,
        fontWeight: 400,
        fontSize: 14
    },
    noteDate:{
        margin: '5px 0 0 0',
        fontWeight: 450,
        fontSize: 14,
        color: theme.palette.secondary.main

    }
    
}))


function Notifications(props) {
    const classes = useStyles()
    const {notifications} = props
    useEffect(() => {
        // console.log({'Props in Notifications': props})
    }, [])
    return (
        <div className={classes.root}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                <h2 className={classes.tabHeading}>Notifications</h2>
            </Box>
            {notifications.map((item, index) => (
                <Paper className={classes.noteContainer} key={index} elevation={2}>
                    <h4 className={classes.noteHeading}>{item.title}</h4>
                    <p className={classes.noteMsg}>{item.message}</p>
                    <p className={classes.noteDate}>{item.date}</p>
                </Paper>
            ))}
        </div>
    )
}

export default Notifications
